import { Observable } from 'rxjs';
import { NgFor } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { maskitoTransform } from '@maskito/core';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { mask_porcentagem_limpa } from '../../directives/mascaras';
import { PQREncargosSociaisDto, PQRMultiplicadorAnualDto } from '../../dtos';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { Router } from '@angular/router';
import { MenuSuspensoComponent } from '../../shared/menu-suspenso/menu-suspenso.component';
import { DialogPqrEncargosSociaisComponent } from '../../shared/dialog-pqr-encargos-sociais/dialog-pqr-encargos-sociais.component';
import { PrecoEncargosAdicionaisStateService } from '../../services/preco-encargos-adicionais-state/preco-encargos-adicionais-state.service';
import { ValidacaoResult, ValidadorTela } from '../../interfaces/validacao.interface';
import { MaskitoDirective } from '@maskito/angular';
import { BasePqrComponent } from '../base-pqr/base-pqr.component';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

interface PQREncargosSociaisTable {
  descricaoItem: string;
  percentual: string;
  isPqrNaoEditavel?: boolean;
}

@Component({
  selector: 'app-encargos-sociais',
  standalone: true,
  imports: [
    NgFor,
    MatTooltip,
    TabelaComponent,
    MatIconModule,
    MatTooltip,
    FormsModule,
    TabelaComponent,
    MenuSuspensoComponent,
    MaskitoDirective],
  templateUrl: './encargos-sociais.component.html',
  styleUrl: './encargos-sociais.component.scss'
})

export class EncargosSociaisComponent extends BasePqrComponent<PQREncargosSociaisDto> implements ValidadorTela {

  protected valoresPadrao: PQREncargosSociaisDto[] = [];
  protected valoresEdicao: PQREncargosSociaisDto[] = [];

  mask_porcentagem_limpa = mask_porcentagem_limpa;
  dadosTabela: PQREncargosSociaisTable[] = [];
  multiplicadorAnualValores: PQRMultiplicadorAnualDto[] = [];

  constructor(
    router: Router,
    toastr: ToastrService,
    dialogRestaurarValoresPadrao: MatDialog,
    private dialogPqrEncargosSociais: MatDialog,
    private precoEncargosAdicionaisStateService: PrecoEncargosAdicionaisStateService,
    private featureFlagService: FeatureFlagService
  ) {
    super(router, toastr, dialogRestaurarValoresPadrao, dialogPqrEncargosSociais);
  }

  ngOnInit(): void {
    if (this.precoEncargosAdicionaisStateService.carregando.getValue()) {
      this.precoEncargosAdicionaisStateService.carregando.subscribe(() => {
        this.carregarDadosInterno();
        return;
      });
      return;
    }

    this.carregarDadosInterno();
  }

  private carregarDadosInterno() {
    this.carregarDados(
      () => this.precoEncargosAdicionaisStateService.getPQREncargosSociaisPadrao(),
      () => this.precoEncargosAdicionaisStateService.getPQREncargosSociaisValores()
    );
    this.processarDadosTabela(this.valoresEdicao);
  }

  private processarDadosTabela(dados: PQREncargosSociaisDto[]): void {
    this.dadosTabela = dados.map((dado) => {
      const dadoTabela: PQREncargosSociaisTable = {
        descricaoItem:
          'Direitos e obrigações trabalhistas (despesa com previdência parte patronal)',
        percentual: maskitoTransform(
          String(dado.percentual),
          mask_porcentagem_limpa,
        ),
        isPqrNaoEditavel: false
      };
      return dadoTabela;
    });

    this.multiplicadorAnualValores = this.precoEncargosAdicionaisStateService.getPQRMultiplicadorAnualValores();
    const multiplicadorHabilitado = this.featureFlagService.funcionalidadeHabilitada('1184-pqr-multiplicador-anual');

    if (multiplicadorHabilitado && this.multiplicadorAnualValores.length > 0) {
      this.dadosTabela.push({
        descricaoItem: 'Multiplicador para o cálculo da despesa anual com pessoal <sup>(1)</sup>',
        percentual: String(this.multiplicadorAnualValores[0].multiplicadorAnual).replace('.', ','),
        isPqrNaoEditavel: false
      });
    } else {
      this.dadosTabela.push({
        descricaoItem: 'Multiplicador para o cálculo da despesa anual com pessoal <sup>(1)</sup>',
        percentual: '13,3',
        isPqrNaoEditavel: true
      });
    }
  }

  atualizarDadosDoServicoDeEstado(): void {
    const multiplicadorHabilitado = this.featureFlagService.funcionalidadeHabilitada('1184-pqr-multiplicador-anual');
    const ultimoIndex = this.dadosTabela.length - 1;

    // Separa os encargos sociais (todos exceto o último que é o multiplicador)
    const dadosEncargos = this.dadosTabela.slice(0, ultimoIndex);
    const dados = dadosEncargos.map(tabela => {
      const dto: PQREncargosSociaisDto = {
        codPqrAdicionaisManutencaoEncargos: 6,
        percentual: Number(tabela.percentual.replace(',', '.'))
      };
      return dto;
    });

    this.valoresEdicao = dados;
    this.atualizarValores();

    // Atualiza o multiplicador anual no state service
    if (multiplicadorHabilitado && this.multiplicadorAnualValores.length > 0) {
      const multiplicadorTabela = this.dadosTabela[ultimoIndex];
      this.multiplicadorAnualValores[0].multiplicadorAnual = Number(multiplicadorTabela.percentual.replace(',', '.'));
      this.precoEncargosAdicionaisStateService.setPQRMultiplicadorAnualValores(this.multiplicadorAnualValores);
    }
  }

  public override restaurarValoresPadrao(): void {
    super.restaurarValoresPadrao();

    const multiplicadorPadrao = this.precoEncargosAdicionaisStateService.getPQRMultiplicadorAnualPadrao();
    this.precoEncargosAdicionaisStateService.setPQRMultiplicadorAnualValores(
      JSON.parse(JSON.stringify(multiplicadorPadrao))
    );

    this.processarDadosTabela(this.valoresEdicao);
  }

  protected atualizarValores() {
    this.precoEncargosAdicionaisStateService.setPQREncargosSociaisValores(this.valoresEdicao);
  }

  protected openDialogPqrValoresPadrao(): void {
    const dialogRef = this.dialogPqrEncargosSociais.open(
      DialogPqrEncargosSociaisComponent,
      {
        panelClass: 'dialog-pqr-encargos-sociais',
      },
    );
    dialogRef.componentInstance.dadosTabela = this.precoEncargosAdicionaisStateService.getPQREncargosSociaisPadrao();
  }

  public criaMensagemInconsistencia(): string[] {
    const mensagens: string[] = [];
    this.dadosTabela.forEach((dado) => {
      const percentual: number = Number(dado.percentual.replace(',', '.'));
      if (percentual < 0 || percentual > 100) {
        mensagens.push(
          `O valor do percentual para o item ${dado.descricaoItem} não é válido.Informe um valor de 0% a 100%`,
        );
      }
    });

    return mensagens;
  }
}

export function canDeactivateFnEncargosSociais
  (component: EncargosSociaisComponent
  ): Observable<boolean> | boolean {
  if (
    component.criaMensagemInconsistencia().length > 0) {
    return false;
  }
  return true;
}
